<template>
  <div class="site-wrapper site-page--not-found">
    <div class="site-content__wrapper">
      <div class="site-content">
        <h2 class="not-found-title">geodata获取</h2>
        <div>
          <input type="text" v-model="reionCode">
          <span>{{regionName}}</span>
          <span>json长度{{jsonCount}}</span>
          <el-button type="primary" class="not-found-btn-gohome" @click="chooseRegion">获取</el-button>
        </div>
        <div>
          <textarea v-model="content" rows="20" style="    width: 100%;"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as $ from 'jquery';
  import * as _ from 'lodash';
  import {previewCode} from '../../utils/preview.js';
  import {initDistrict, loadAreaNode} from '../../utils/amap.js';

  export default {
    data() {
      return {
        currentAreaNode: null,
        districtExplorer: null,
        reionCode: window.SITE_CONFIG.regionCode,
        content: '',
        zoom:3,
        jsonCount:0,
        regionName: ''
      }
    },
    methods: {
      chooseRegion: function () {
        console.log(this.reionCode)
        loadAreaNode(this.districtExplorer, this.reionCode, (result) => {
          this.initMapData(result)
        })
      },
      initMapData(result) {
        //this.content = previewCode({data: result.mapData})
        this.content = JSON.stringify(result.mapData)
        this.jsonCount=this.content.length
        this.regionName = result.regionName
      }
    },
    mounted() {
      let _self=this
      jQuery('#mount').append('<div id="china" style="width: 50%;height:400px;position: absolute;left: 0;top: 0;"></div>');
      $.getScript('https://webapi.amap.com/maps?v=1.4.1&key=0d78256ea89beeb8c25d1cd047549d1f')
        .then(() => $.getScript('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11'))
        .then(() => {
          initDistrict(_self.regionCode, (result) => {
            _self.districtExplorer = result.districtExplorer
            _self.initMapData(result)
          },_self.zoom)
        })
    },
  }
</script>

<style lang="scss">
  .site-wrapper.site-page--not-found {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;

    .site-content__wrapper {
      padding: 0;
      margin: 0;
      background-color: #fff;
    }

    .site-content {
      position: fixed;
      top: 15%;
      left: 50%;
      z-index: 2;
      padding: 30px;
      text-align: center;
      transform: translate(-50%, 0);
    }

    .not-found-title {
      margin: 20px 0 15px;
      font-size: 10em;
      font-weight: 400;
      color: rgb(55, 71, 79);
    }

    .not-found-desc {
      margin: 0 0 30px;
      font-size: 26px;
      text-transform: uppercase;
      color: rgb(118, 131, 143);

      > em {
        font-style: normal;
        color: #ee8145;
      }
    }

    .not-found-btn-gohome {
      margin-left: 30px;
    }
  }
</style>
